import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';

import DiscoverButton from '../../shared_components/DiscoverButton/DiscoverButton';
import useIsMobile from '../../shared_components/hooks/useIsMobile';
import NavButtons from '../NavigationButtons/NavButtons';

import styles from './DiscoverInternalTable.module.scss';

type ReduxProps = ConnectedProps<typeof connector>;

type Props = {
    tableNames?: Array<string>;
    tableHeaders?: Array<string>;
    onTabChange?: (index: number) => void;
    renderList: JSX.Element | JSX.Element[];
    hasViewMoreButton?: boolean;
    onViewMoreClick: () => void;
    isViewMoreDisabled?: boolean;
    initialActiveTab?: number;
}

const DiscoverInternalTable = (props: Props & ReduxProps) => {
  const {
    tableNames,
    tableHeaders,
    onTabChange,
    renderList,
    hasViewMoreButton,
    onViewMoreClick,
    isViewMoreDisabled,
    initialActiveTab = 0,
  } = props;

  const { isMobile } = useIsMobile();

  const tabs = [
    {
      text: tableNames ? tableNames[0] : '',
      component: <></>,
    },
    {
      text: tableNames ? tableNames[1] : '',
      component: <></>,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <NavButtons
        fullWidthButtons
        tabs={tabs}
        sendCurrentTabIndex={onTabChange}
        initialActiveTab={initialActiveTab}
      />
      <div className={styles.tableWrapper}>
        {!isMobile && tableHeaders && (
        <div className={styles.tableHead}>
          {tableHeaders.map((header: string) =>
            <div className={styles.header} key={header}>{header}</div>)}
        </div>
        )}
        <div>
          {renderList}
        </div>
        {hasViewMoreButton && (
          <div className={styles.viewMoreButtonWrapper}>
            <DiscoverButton
              text={lang.commonLoadMore()}
              onClick={onViewMoreClick}
              className={styles.viewMoreButton}
              disabled={isViewMoreDisabled}
             />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
});

const connector = connect(mapStateToProps);

export default connector(DiscoverInternalTable);
